export let data = {
  title: "Detail Pembayaran",
  backBtn: "/kasir",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir Rawat", link: "/kasir" },
    { title: "Detail Pembayaran", active: true },
  ],
};

export let dataRalan = {
  title: "Detail Pembayaran",
  backBtn: "/kasir/ralan",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir Rawat Jalan", link: "/kasir/ralan" },
    { title: "Detail Pembayaran", active: true },
  ],
};

export let dataRanap = {
  title: "Detail Pembayaran",
  backBtn: "/kasir/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir Rawat Inap", link: "/kasir/ranap" },
    { title: "Detail Pembayaran", active: true },
  ],
};

export let dataUgd = {
  title: "Detail Pembayaran",
  backBtn: "/kasir/ugd",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir UGD", link: "/kasir/ugd" },
    { title: "Detail Pembayaran", active: true },
  ],
};
export let dataObat = {
  title: "Detail Pembayaran",
  backBtn: "/kasir/obat",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir Obat", link: "/kasir/obat" },
    { title: "Detail Pembayaran", active: true },
  ],
};
export let dataOptik = {
  title: "Detail Pembayaran",
  backBtn: "/kasir/optik",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir Optik", link: "/kasir/optik" },
    { title: "Detail Pembayaran", active: true },
  ],
};
export let dataLab = {
  title: "Detail Pembayaran",
  backBtn: "/kasir/lab",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir lab", link: "/kasir/lab" },
    { title: "Detail Pembayaran", active: true },
  ],
};

export let dataOperasi = {
  title: "Detail Pembayaran",
  backBtn: "/kasir/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Kasir operasi", link: "/kasir/operasi" },
    { title: "Detail Pembayaran", active: true },
  ],
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6,
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6,
      },
    ],
  },
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps",
  },
];

export let jumlahForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Jumlah Bayar",
        type: "money",
        placeholder: "Masukkan Jumlah Bayar",
        name: "jumlah_bayar",
        value: "100000",
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "checkbox_old",
        placeholder: "",
        name: "lunas",
        value: [],
        mandatory: true,
        options: [{ value: "1", label: "Lunasi Pembayaran ini" }],
      },
    ],
  },
];
export let diskonForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "radio",
        placeholder: "",
        name: "diskon_type",
        value: "Rp",
        defaultValue: "Rp",
        mandatory: true,
        multiple: false,
        options: [
          { value: "Rp", label: "Jumlah Fix" },
          { value: "Percentage", label: "Persentase" },
        ],
        additional: "",
      },
      {
        label: "",
        type: "money",
        placeholder: "Jumlah Diskon",
        name: "diskon",
        value: "",
        optional: false,
        mandatory: true,
      },
    ],
  },
];
export let bayarForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Jumlah Bayar",
        type: "money",
        placeholder: "Masukkan Jumlah Bayar",
        name: "jumlah",
        value: "",
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "checkbox_old",
        placeholder: "",
        name: "lunas",
        value: [],
        optional: true,
        options: [{ value: "1", label: "Lunasi Pembayaran ini" }],
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Cara Bayar",
        type: "radio",
        placeholder: "",
        name: "cara_bayar",
        value: "Tunai",
        defaultValue: "Tunai",
        mandatory: true,
        multiple: false,
        options: [
          { value: "Tunai", label: "Tunai" },
          { value: "Debet/Kredit", label: "Debet/Kredit" },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Pilih Bank",
        type: "hidden",
        placeholder: "",
        name: "id_bank",
        value: "",
        optional: true,
        options: [],
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Nomor Kartu Debit/Kredit",
        type: "hidden",
        placeholder: "",
        name: "no_kartu",
        value: "",
        optional: true,
      },
    ],
  },
];

export let labTypeForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "Petugas Lab",
        type: "select",
        placeholder: "Pilih Petugas Lab",
        name: "id_petugas_lab",
        value: "",
        mandatory: true,
        multiple: false,
        options: [],
        additional: "",
        colwidth: 8,
      },
    ],
  },
];
